export const SET_SITE_TOUR_DATA = "SET_SITE_TOUR_DATA"
export const SET_SITE_TOUR_DATA_IS_NOTIFIED = "SET_SITE_TOUR_DATA_IS_NOTIFIED"